import { render, staticRenderFns } from "./VBadge.vue?vue&type=template&id=33d202f8&"
import script from "./VBadge.vue?vue&type=script&lang=js&"
export * from "./VBadge.vue?vue&type=script&lang=js&"
import style0 from "./VBadge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports